import { Injectable } from "@angular/core";
import { Params } from "@angular/router";

@Injectable({ providedIn: "root" })
export class ListStateService {
  private readonly state = new Map<string, Params>();

  private key(path: string): string {
    return path.replace(/^\/+|\/+$/g, "");
  }

  set(path: string, params: Params): void {
    this.state.set(this.key(path), { ...params });
  }

  get(path: string): Params {
    return this.state.get(this.key(path)) ?? {};
  }
}
